import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { DoctorCard } from './DoctorCard';
import { SlotsPreviewTable } from './SlotsPreviewTable';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const SlotsPreview = ({ doctorSlots, doctorProfileDetails }) => {
  const doctorDetails = doctorProfileDetails?.doctors[0]
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <React.Fragment>
      {doctorSlots && doctorSlots.length > 0 && <button className='flex flex-col justify-center border rounded-lg px-6 py-2 border-[#DBE0E6] text-[#252D38] font-semibold'
        style={{ color: '#252D38' }}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClickOpen(); }}>
        Customer View
      </button>
      }
      <BootstrapDialog
        onClose={(e) => { e.preventDefault(); e.stopPropagation(); handleClose(); }}
        open={open}
        maxWidth={'md'}
        fullWidth
        sx={{paddingTop:0}}
        style={{ paddingTop: 0 }}
      >
        <DialogTitle sx={{ m: 0, p: 2}} id="customizepd-dialog-title" className='text-2xl font-semibold ' style={{fontSize:'1.5rem', }}>
          <div  style={{ fontFamily: 'Lexend Deca'}}>  Preview (As seen by Customers) </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <Divider variant="middle" />
        <DialogContent className='bg-white flex flex-col h-[80vh] z-10' style={{ paddingTop: 0 }}  sx={{paddingTop:0}}>
          <div className="flex flex-col gap-2 flex-start">
            <div className="sticky top-0 z-10 bg-white" style={{paddingTop:'1rem'}}>
            <DoctorCard doctorDetails={doctorDetails} />
            <Divider variant="middle" className='my-4' style={{marginTop:'1rem', marginBottom:'0.5rem'}} />
            </div>
            <SlotsPreviewTable doctorSlots={doctorSlots}/>
          </div>

        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
